import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-depotGoods",
  "use": "icon-depotGoods-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-depotGoods\"><defs><style type=\"text/css\"></style></defs><path d=\"M960 253.184l-448-192-448 192v547.392l448 190.72 38.688-16.48h8.192v-3.488L960 800.608V253.184z m-448 163.424l-113.536-48.32 318.944-147.2c0.736-0.352 1.216-0.992 1.92-1.408l127.232 54.528L512 416.608z m128.704-230.624l-321.696 148.48-141.568-60.288L512 130.816l128.704 55.168zM128 322.688l128 54.496V576a32 32 0 1 0 64 0v-171.52l0.064-0.032 174.816 74.432v435.584L128 758.272V322.688z m430.88 579.104V466.208L896 322.688v435.616l-337.12 143.488z\" p-id=\"1871\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/depotGoods.svg
// module id = ql4r
// module chunks = 81